import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { CampaignParticipantProps, PublicPlayerProps } from "../../types"
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import { Image } from 'react-native';
import ProgressTimer from './ProgressTimer';

type NewPlayerAlertProps = {
    view_mode:'desktop'|'mobile',
    player:PublicPlayerProps,
    campaign_participant:CampaignParticipantProps,
    onViewProfile?:(player:PublicPlayerProps) => void
    onClose:() => void
}

const GolferAlert = ({ player, view_mode, campaign_participant, onClose, onViewProfile }:NewPlayerAlertProps) => {
    const Colors = useColors();
    return (
        <View float style={{ width:350 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:18, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:20, marginRight:10 }}>
                    <Text theme='h1'>NEW CLOSEST TO THE PIN RESULT!</Text>
                    <Text theme='description' style={{ marginTop:5 }}>{player.first_name} {player.last_name}</Text>
                </View>
            </View>
            <View type='body'>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:200, width:350 }}
                    resizeMode='cover'
                />
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>    
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>{player.first_name} {player.last_name}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>Windsong Farms Hole 16</Text>
                    </View>
                    <View transparent style={{ alignItems:'flex-end' }}>
                        <Text theme='h1' size={40}>{campaign_participant.payload.pin_distance}</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Feet</Text>
                    </View>
                </View>
            </View>
            <View type='footer' style={{ borderBottomRightRadius:view_mode == 'desktop' ? 8: 0, borderBottomLeftRadius:view_mode == 'desktop'?8:0 }}>
                <ProgressTimer
                    onTimesUp={() => onClose()}
                    time_id={campaign_participant.campaign_participant_id.toString()}
                    total_time={20}
                />
            </View>
            {view_mode == 'mobile' ?
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', borderBottomRightRadius:8, borderBottomLeftRadius:8, padding:10 }}>
                {onViewProfile ?
                <Button
                    title='View Profile'
                    type='success'
                    style={{ flex:1, marginRight:3 }}
                    onPress={() => onViewProfile(player)}
                />
                :<></>}
                <Button
                    title='CLOSE'
                    type='error'
                    style={{ flex:1, marginLeft:3 }}
                    onPress={() => onClose()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default GolferAlert